export const isProd = process.env.REACT_APP_ENVIRONMENT === 'production';

export const HEADER_TOKEN_NAME = 'x-iaa-api-token';
export const EXPERIMENT_APP_URL = isProd ? 'app-sep.iqm.com' : 'app-sep.stage.iqm.com';